module.exports = __webpack_public_path__ + "static/media/fj.453532c2.svg";